import {
	ProgramResponse as ProgramV2Response,
	ProgramResponseCheckoutMode as ProgramV2ResponseCheckoutMode,
} from "@getbread/api-client-program-v2";

export const isEcommerceProgram = ({ channel }: ProgramV2Response) => channel === "ECOMM";

export const isInstoreProgram = ({ channel }: ProgramV2Response) => channel === "INSTORE";

export const hasCheckoutSDKAccess = ({ displayInterestRateBPS }: ProgramV2Response) =>
	!!displayInterestRateBPS && displayInterestRateBPS > 0;

// TODO use this in useTransactionData to enrich the transaction data with the program's checkout mode, and then we can remove the getProgramCheckoutMode util function in that file.
export const isVirtualCardProgram = ({ checkoutMode }: ProgramV2Response) =>
	checkoutMode === ProgramV2ResponseCheckoutMode.VirtualCard;
